import React, { Component } from 'react';
import axios from 'axios';
import Mustache from 'mustache';
import { SetComponentLanguage, ApiRequest, ReturnLegendClass, ReturnSeatStatusClass, ReturnSeatStatus } from '../../../helpers';
import EventPriceOptionsModal from '../../Common/EventPriceOptionsModal/EventPriceOptionsModal';
import Message from '../../Common/Message/Message';
import ReactHtmlParser from 'react-html-parser';
import Slider from 'react-rangeslider'
import { ElementPan } from '../../../lib/react-element-pan/src/element-pan';
import moment from 'moment-timezone';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import quickSelectionIcon from '../../../images/icons/flash.svg';
import fullScreenIcon from '../../../images/icons/full-screen.svg';
import 'react-rangeslider/lib/index.css'
import './ReservedSeating.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let channel;

class ReservedSeating extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rendered: null,
            direction: '',
            isEventPriceOptionsOpen: false,
            pricingOptions: [],
            venuePricingOptions: [],
            venue: {},
            currentPrice: {},
            zoom: 40,
            css: {
                transform: "scale(0.4,0.4)"
            },
            message: {
                title: '',
                content: '',
                type: ''
            },
            selectedTicketId: null,
            type: undefined,
            seatId: undefined,
            ticket_id: undefined,
            customerId: null,
            customerName: null,
            transactionId: null,
            isQuickSelect: false,
            isFullScreen: false,
            section_name: undefined,
            row_name: undefined,
            seat_name: undefined,
            is_social_distance: false,
        };
        this.sectionsMarkup = {};
        this.sectionsMarkupNoRowNames = {};
        this.tablesMarkup = {};
        this.sectionNames = {};
        this.template = '';
    }

    handleChangeStart = () => {
        console.log('Change event started')
    };
    
    handleChange = (value) => {
        this.setState({
            zoom: value
        });
        var scale = 'scale(' + value/100 + ',' + value/100 + ')';
        const css = {...this.state.css};
        css.transform = scale;
        this.setState({ css });
    };
    
    handleChangeComplete = () => {
        console.log('Change event completed')
    };

    toggleFullScreen = () => {
        this.setState(
            {
                isFullScreen: !this.state.isFullScreen,
            },
            () => {
                if (this.state.isFullScreen) {
                    this.handleChange(50);
                } else {
                    this.handleChange(this.props.ticketSelection.zoom_level);
                }
            }
        );
    };

    createVenueSectionsMarkup = (sections, removeRowNames) => {
        sections.forEach(section => {
        let markup;
        removeRowNames === true ? markup = this.sectionsMarkupNoRowNames : markup = this.sectionsMarkup;
        markup[section.section_id] =
            `<div id="seat-map-${section.section_id}" class="seatCharts-container ${section.justify} ${section.color}" tabindex="0">
                ${section.rows.map(row => {
                    return (
                        `<table role="presentation">
                            <tr>
                                ${row.seats.map((seat, index) => {
                                    let startRowName = '';
                                    let endRowName = '';
                                    const seatChartsSpace = `<td><div class="seatCharts-cell seatCharts-space">${row.row_name}</div></td>`;
                                    if (index === 0 && !removeRowNames) {
                                        startRowName = seatChartsSpace;
                                    } else if (index === row.seats.length - 1 && !removeRowNames) {
                                        endRowName = seatChartsSpace;
                                    }
                                    let seatName = `${section.section_name}:${row.row_name}:${seat.seat_name}`;
                                    return (
                                        `${startRowName}
                                            <td>
                                                <button 
                                                    data-seat-id="${seat.seat_id}"
                                                    data-row-id="${row.row_id}" 
                                                    data-section-id="${section.section_id}" 
                                                    data-seat-status="${ReturnSeatStatus(seat.status, seat.social_distance)}"
                                                    data-seat-type="${ReturnLegendClass(seat.type)}"
                                                    data-section-name="${section.section_name}"
                                                    data-row-name="${row.row_name}"
                                                    data-seat-name="${seat.seat_name}"
                                                    data-social-distance="${seat.social_distance}"
                                                    data-tooltip="${seatName}"
                                                    data-event-date-id="${this.props.ticketSelection.event_date_id}"
                                                    aria-label="${seatName} - ${ReturnSeatStatusClass(seat.status, this.props.user, seat.social_distance)}"
                                                    class="clickable-seat seatCharts-cell seatCharts-seat ${ReturnSeatStatusClass(seat.status, this.props.user, seat.social_distance)} ${ReturnLegendClass(seat.type)}">
                                                    ${seat.seat_name}
                                                </button>
                                            </td>
                                        ${endRowName}`
                                    )
                                }).join('')
                                }
                            </tr>
                        </table>`
                    )
                }).join('')
                }
            </div>`;
            this.sectionNames[section.section_id] = `<div class="front-indicator">${section.section_name}</div>`;
        });
    }

    createTableSectionsMarkup = (sections) => {
        sections.forEach(section => {
            this.tablesMarkup[section.section_id] = {};
            section.rows.map(row => {
                return row.seats.map(seat => {
                    return this.tablesMarkup[section.section_id][seat.seat_name] = `<button 
                                                                                        data-table-seat
                                                                                        data-seat-id=${seat.seat_id} 
                                                                                        data-row-id="${row.row_id}" 
                                                                                        data-section-id="${section.section_id}"
                                                                                        data-seat-status="${ReturnSeatStatus(seat.status, seat.social_distance)}"
                                                                                        data-seat-type="${ReturnLegendClass(seat.type)}"
                                                                                        data-event-date-id="${this.props.ticketSelection.event_date_id}"
                                                                                        aria-label="${section.section_id}:${row.row_id}:${seat.seat_id} - ${ReturnLegendClass(seat.type)} - ${ReturnSeatStatusClass(seat.status, this.props.user, seat.social_distance)}"
                                                                                        class="seatCharts-seat clickable-seat ${ReturnSeatStatusClass(seat.status, this.props.user, seat.social_distance)} ${ReturnLegendClass(seat.type)}">
                                                                                        ${seat.seat_name}
                                                                                    </button>`;
                })
            })
        })
    }

    mergeTemplateAndData = () => {
        const rendered = Mustache.render(this.template.data, { 
            sectionNames: this.sectionNames, 
            sectionsMarkup: this.sectionsMarkup, 
            sectionsMarkupNoRowNames: this.sectionsMarkupNoRowNames, 
            tablesMarkup: this.tablesMarkup 
        });
        this.setState({ rendered }, () => {
            this.bindClickEventToCells();
            
            // Add class is-table to layout to add margin
            const tableSeats = Array.from(document.querySelectorAll('[data-table-seat]'));
            if(tableSeats.length > 0) {
                const seatingWrapper = Array.from(document.querySelectorAll('.showtix-seating-wrapper'));
                if(seatingWrapper.length > 0){
                    seatingWrapper.map((wrapper) => {
                        wrapper.classList.add('is-table');
                    })
                };
            }
        });
    }

    bindClickEventToCells = () => {
        const cellsArray = Array.from(document.querySelectorAll('.clickable-seat'));
        cellsArray.map(cell => {
            cell.addEventListener('mousedown', this.handleSeatClick, false);

            // Accessibility - Add keypress event
            cell.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') {
                    this.handleSeatClick(e);
                }
            }, false);
        })
    }

    handlePriceChange = (e) => {
        let id = e.target.value;
        let currentPrice = { ...this.state.currentPrice };
        this.state.pricingOptions.forEach((price) => {
            if (price.id === parseInt(id, 0)) {
                currentPrice = price;
            }
        });
        this.setState(
            {
                currentPrice
            },
            () => {
                this.confirmEventPriceOption();
            }
        );
    }

    updateSeats = () => {
        let seats = document.querySelectorAll('.clickable-seat');
        let cartItems = this.props.cartItems;

        cartItems.forEach((cartItem) => {
            cartItem.forEach((ticket) => {
                if (ticket.social_distance) {
                    seats.forEach((seat) => {
                        if(parseInt(seat.dataset.seatId) === parseInt(ticket.seat_id) && 
                            parseInt(seat.dataset.sectionId) === parseInt(ticket.section_id) && 
                            parseInt(seat.dataset.rowId) === parseInt(ticket.row_id) &&
                            parseInt(seat.dataset.eventDateId) === parseInt(ticket.event_date_id)) {
                                
                            seat.classList.remove("social-distance", "available", "held", "unavailable", "released", "sold");
                            seat.setAttribute('data-seat-status','social-distance');
                            seat.classList.add("social-distance");
                            //seat.classList.add("unavailable");
                            seat.setAttribute('aria-label', `${seat.dataset.tooltip} - Social distancing seat`);
                        }
                    });
                } else {
                    seats.forEach((seat) => {
                        if(parseInt(seat.dataset.seatId) === parseInt(ticket.seat_id) && 
                            parseInt(seat.dataset.sectionId) === parseInt(ticket.section_id) && 
                            parseInt(seat.dataset.rowId) === parseInt(ticket.row_id) && 
                            parseInt(seat.dataset.eventDateId) === parseInt(ticket.event_date_id)) {
                                
                            seat.classList.remove("social-distance", "available", "held", "unavailable", "released", "sold");
                            seat.setAttribute('data-seat-status','held');
                            seat.classList.add("held");
                            //seat.classList.add("unavailable");
                            seat.setAttribute('aria-label', `${seat.dataset.tooltip} - Held`);
                        }
                    });
                }
            });
        });
    }

    handleSeatClick = async (e) => {
        let isQuickSelect = this.state.isQuickSelect;
        e.stopImmediatePropagation();

        // check if clicked seat is already in cart - if so, delete from cart
        const clickedSeatId = parseInt(e.target.dataset.seatId, 0);
        let isAlreadyInCart = false;

        console.log('cartItems', this.props.cartItems)
        this.props.cartItems.forEach(eventDate => {
            for (var i = 0; i < eventDate.length; i++) {
                if (clickedSeatId === eventDate[i].seat_id && eventDate[i].event_date_id === this.props.ticketSelection.event_date_id) {
                    if (!eventDate[i].social_distance) {
                        isAlreadyInCart = true;
                        console.log('delete from cart')
                        this.props.deleteFromCart(eventDate[i]);
                    }
                    return;
                }
            }
        });

        this.setState({
            type: e.target.dataset.seatStatus
        });

        if (e.target.dataset.seatType === 'unavailable' || e.target.dataset.seatType === 'empty' || isAlreadyInCart) {
            return;
        }

        const section_name = e.target.dataset.sectionName;
        const row_name = e.target.dataset.rowName;
        const seat_name = e.target.dataset.seatName;
        let isReserved = false;

        if (e.target.dataset.seatStatus === 'held' || e.target.dataset.seatStatus === 'sold' || e.target.dataset.seatStatus === 'reserved' || e.target.dataset.seatStatus === 'social-distance') {
            // If a seat is held, allow user to remove it and block other
            /* if(!isAlreadyInCart){
                return;
            } */

            isReserved = true;

            if (!this.props.user) {
                return;
            }

            if (e.target.dataset.seatStatus === 'held') {
                return;
            }

            console.log(clickedSeatId)

            // If client, see https://github.com/DigitalTheatre/showtix4u-ui/issues/320
            // If box office, see https://github.com/DigitalTheatre/showtix4u-ui/issues/793
            if (this.props.user.role === 'client' || this.props.user.role === 'box-office') {
                this.setState({
                    row_id: parseInt(e.target.dataset.rowId, 0),
                    section_id: parseInt(e.target.dataset.sectionId, 0),
                    seatId: clickedSeatId,
                    section_name,
                    row_name,
                    seat_name,
                    is_social_distance: e.target.dataset.socialDistance === 'false' ? false : true,
                });
                await this.getEventDate(this.props.ticketSelection.event_date_id);
            } else {
                console.log('e.target.dataset', e.target.dataset)
                if (e.target.dataset.seatStatus === 'social-distance') {
                    this.setState({
                        row_id: parseInt(e.target.dataset.rowId, 0),
                        section_id: parseInt(e.target.dataset.sectionId, 0),
                        seatId: clickedSeatId,
                        section_name,
                        row_name,
                        seat_name,
                        is_social_distance: e.target.dataset.socialDistance === 'false' ? false : true,
                    });
                    await this.getEventDate(this.props.ticketSelection.event_date_id);
                } else {
                    return;
                }
            }
        }
        
        const section_id = parseInt(e.target.dataset.sectionId, 0);
        const row_id = parseInt(e.target.dataset.rowId, 0);
        const seat_id = parseInt(e.target.dataset.seatId, 0);
        const seat_type = e.target.dataset.seatType;

        const {event_date, pricing_options} = this.state.venue;
        let pricingOptions = [];
        event_date.section_pricing.find((section) => section.id === section_id)
            .options.map((option) => {
                // events - Pricing Visibility #358
                // Show prices depending on their visibility status
                if(option.value === 'all' || option.value === 'box-office') {
                    if(this.props.user) {
                        if(this.props.user.role === 'box-office' || this.props.user.role === 'client'){
                            pricing_options.map((pricing_option) => {
                                if (option.id === pricing_option.id) {
                                    pricing_option['value'] = option.value;
                                    pricing_option['event_date_id'] = event_date.id;
                                    pricing_option['pricing_option_id'] = pricing_option.id;
                                    pricing_option['section_id'] = section_id;
                                    pricing_option['row_id'] = row_id;
                                    pricing_option['seat_id'] = seat_id;
                                    pricing_option['seat_type'] = seat_type;
                                    pricingOptions.push(pricing_option);
                                }
                            });
                        } else {
                            if(option.value !== 'box-office'){
                                pricing_options.map((pricing_option) => {
                                    if (option.id === pricing_option.id) {
                                        pricing_option['value'] = option.value;
                                        pricing_option['event_date_id'] = event_date.id;
                                        pricing_option['pricing_option_id'] = pricing_option.id;
                                        pricing_option['section_id'] = section_id;
                                        pricing_option['row_id'] = row_id;
                                        pricing_option['seat_id'] = seat_id;
                                        pricing_option['seat_type'] = seat_type;
                                        pricingOptions.push(pricing_option);
                                    }
                                });
                            }
                        }
                    } else {
                        pricing_options.map((pricing_option) => {
                            if (option.id === pricing_option.id) {
                                pricing_option['value'] = option.value;
                                pricing_option['event_date_id'] = event_date.id;
                                pricing_option['pricing_option_id'] = pricing_option.id;
                                pricing_option['section_id'] = section_id;
                                pricing_option['row_id'] = row_id;
                                pricing_option['seat_id'] = seat_id;
                                pricing_option['seat_type'] = seat_type;
                                pricingOptions.push(pricing_option);
                            }
                        });
                    }
                }
            });
        this.setState({
            section_name,
            row_name,
            seat_name,
            pricingOptions,
            currentPrice : pricingOptions[0]
        }, async () => {
            // Hold a ticket on click for Websocket to update seat status
            try {
                const ticketSelection = {
                    event_date_id: event_date.id,
                    section_id: section_id,
                    row_id: row_id,
                    seat_id: seat_id,
                    isReserved: isReserved,
                }

                // Only pass ID when the seat was selected
                if (ticketSelection.isReserved) {
                    ticketSelection['id'] = this.state.ticket_id; //ticketSelection.seat_id;
                }

                console.log('ticketSelection', ticketSelection)

                if (this.state.isQuickSelect || (!(pricingOptions.length > 1) && this.state.type !== 'held' && this.state.type !== 'sold' && this.state.type !== 'reserved')) {
                    this.quickSelectFlow();
                } 
                else {
                    console.log('ticketSelection before sending call to API', ticketSelection);
                    if (this.state.type !== 'sold' && this.state.type !== 'reserved') {
                        const holdTicketsResponse = await this.props.postReservedAdmissionTickets(this.props.user, ticketSelection, ticketSelection.isReserved ? this.state.ticket_id : null, isQuickSelect);
                        console.log('Post Hold Ticket: ', holdTicketsResponse);

                        if (holdTicketsResponse.data.ticket) {
                            this.setState({
                                selectedTicketId: holdTicketsResponse.data.ticket.id,
                            });
                        } else {
                            // if holdTicketsResponse is an iterable find its first error message
                            let errorMessage = holdTicketsResponse.data.error.code;
                            this.setMessage(window.general_strings.msg.oops, errorMessage, 'error');
                            setTimeout(() => {
                                this.setMessage('', '', '');
                            }, 3000);
                            this.setState({
                                selectedTicketId: this.state.ticket_id,
                            });
                        }
                    }
                    await this.toggleEventPriceOption();
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    // This retrieves the complete seat map of the venue, which seats have which transactions/customer
    getEventDate = async (eventDateId) => {
        try {
            const response = await getLayout(eventDateId);
            console.log('Get Layout Response: ', response);
            const ticketMap = Object.keys(response.data.ticketMap).map(function(key) {
                return [Number(key), response.data.ticketMap[key]];
            });
            ticketMap.map((ticket) => {
                if(ticket[1].seat_id === this.state.seatId) {
                    console.log('========ticket', ticket[1])
                    //if(ticket[1].status === 'V'){


                        // Github #331
                        // If it's a reserved ticket, the user can add it to its cart
                        // We use the ticketId to call the API to update the ticket status
                        this.setState({
                            customerId: ticket[1].customer_id,
                            ticket_id: ticket[1].id,
                            transactionId: ticket[1].transaction_id,
                        }, () => {
                            if(this.state.customerId) {
                                this.getCustomerName(this.state.customerId);
                            } else {
                                this.setState({
                                    customerId: undefined,
                                    customerName: undefined,
                                });
                            }
                        });
                }
            })            
        } catch (error) {
            console.log(error)
        }
        
        async function getLayout(eventDateId) {
            return await ApiRequest(`/event-dates/${eventDateId}/layout`);
        }
    }

    // This retrieves the name of the customer of the seat
    getCustomerName = async (customerId) => {
        console.log(customerId)
        try {
            const response = await getCustomer(customerId);
            console.log('Response: ', response);
            this.setState({
                customerName: response.data.customer.first_name + ' ' + response.data.customer.last_name,
            })
        } catch (error) {
            console.log(error)
        }
        
        async function getCustomer(customerId) {
            return await ApiRequest(`/customers/${customerId}`);
        }
    }

    toggleEventPriceOption = async (e) => {
        this.setState({
            isEventPriceOptionsOpen: !this.state.isEventPriceOptionsOpen,
        }, () => {
            if(!this.state.isEventPriceOptionsOpen) {
                if (this.state.type !== 'sold') {
                    this.setState({
                        type: undefined,
                        ticket_id: undefined,
                        transactionId: undefined,
                        seatId: undefined,
                        is_social_distance: false,
                    }, async () => await this.releaseTicketReserved());
                }
            }
        });
    }

    releaseTicketReserved = async () => {
        // Release seat if user closes the lightbox without chosing a price
        console.log('TYPE', this.state.type)
        const releaseResponse = await releaseTickets(this.props.user, this.state.selectedTicketId);
        console.log('release Ticket: ', releaseResponse);
        if(releaseResponse.data.ticket){
            this.setState({
                selectedTicketId: null
            });
        } else {
            if (releaseResponse.data.error) {
                this.setMessage(window.general_strings.msg.oops, releaseResponse.data.error.code, 'error');
            }
            
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        }

        async function releaseTickets(user, selectedTicketId) {
            let query;
            user.role ? query = `/box-office/cart/${selectedTicketId}` : query = `/tickets/cart/${selectedTicketId}`;
            return await ApiRequest(query, {
                method: 'DELETE'
            });
        }
    }
    
    confirmEventPriceOption = async () => {
        let isQuickSelect = this.state.isQuickSelect;
        let ticket_id = this.state.selectedTicketId || null;
        let isSocialDistance = this.state.type === 'social-distance';
        if (this.state.type === 'reserved') {
            ticket_id = this.state.ticket_id;
        }
        this.props.updateTicketsInCart(this.state.currentPrice, this.props.ticketSelection.type, ticket_id, isSocialDistance, isQuickSelect);

        this.setState({isEventPriceOptionsOpen: false});
    }

    getVenueData = async (dateId) => {
        return await ApiRequest(`/event-dates/${dateId}/layout`);
    }

    getVenue = async () => {
        console.log('Get venue method');
        try {
            const responseVenue = await this.getVenueData(this.props.ticketSelection.event_date_id);
            console.log('Get Venue Data Response: ', responseVenue);
            if (!responseVenue.data.error) {
                this.template = await axios(`${process.env.REACT_APP_CLIENT_URL}/venues/${responseVenue.data.venue.id}.mst`);
                this.createVenueSectionsMarkup(responseVenue.data.venue.sections);
                this.createVenueSectionsMarkup(responseVenue.data.venue.sections, true);
                this.createTableSectionsMarkup(responseVenue.data.venue.sections);
                this.mergeTemplateAndData();
                this.setState({
                    venue: responseVenue.data
                }, () => {
                    this.getVenuePricingOptions();
                    this.listenToChannel();
                });
            } else {
                this.setMessage(window.general_strings.msg.oops, responseVenue.data.error.code, 'error');
                setTimeout(() => {
                    this.setMessage('', '', '');
                }, 3000);
            }
        } catch (error) {
            this.setMessage(window.general_strings.msg.oops, error, 'error');
            setTimeout(() => {
                this.setMessage('', '', '');
            }, 3000);
        }

    }

    getVenuePricingOptions = () => {
        const venuePricingOptions = {};
        const event_date = {...this.state.venue.event_date};
        const pricing_options = [...this.state.venue.pricing_options];
        event_date.section_pricing.forEach(section => {
            section.options.forEach(option => {
                if (option.value === 'all' || option.value === 'box-office') {
                    if (this.props.user.role === 'box-office' || this.props.user.role === 'client') {
                        pricing_options.forEach((pricing_option) => {
                            if (option.id === pricing_option.id) {
                                    venuePricingOptions[pricing_option.id] = {
                                    value: option.value,
                                    amount: pricing_option.amount,
                                    desc: pricing_option.desc
                                }
                            }
                        });
                    } else {
                        if (option.value !== 'box-office') {
                            pricing_options.map((pricing_option) => {
                                if (option.id === pricing_option.id) {
                                        venuePricingOptions[pricing_option.id] = {
                                        value: option.value,
                                        amount: pricing_option.amount,
                                        desc: pricing_option.desc
                                    }
                                }
                            });
                        }
                    }
                }
            })
        })
        this.setState({
            venuePricingOptions: Object.values(venuePricingOptions)
        })
    }

    generateSaveZoomVenue = () => {
        if (this.props.user.role === 'client' || this.props.user.role === 'box-office') {
            return (
                <div className="row">
                    <div className="col-12 d-flex justify-content-center mt-3 mb-3">
                        <button
                            className="showtix-button showtix-background__primary-3"
                            onClick={() => this.props.saveZoomLevel(this.state.zoom)}
                        >
                            {strings.saveZoom}
                        </button>
                    </div>
                </div>        
            );
        } else {
            return null;
        }
    };

    quickSelect = () => {
        this.setState({ isQuickSelect: !this.state.isQuickSelect });
    }

    quickSelectFlow = async () => {
        let isQuickSelect = this.state.isQuickSelect;
        let ticket_id = this.state.selectedTicketId || null;
        let isSocialDistance = this.state.type === 'social-distance';
        if (this.state.type === 'reserved') {
            ticket_id = this.state.ticket_id;
        } 
        this.props.updateTicketsInCart(this.state.currentPrice, this.props.ticketSelection.type, ticket_id, isSocialDistance, isQuickSelect);
    }

    setMessage = (title, content, type) => {
        const message = { ...this.state.message };
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    clearHeldStatusFromDom = async () => {
        let seats = document.querySelectorAll('.clickable-seat.seatCharts-seat.held, .clickable-seat.seatCharts-seat.social-distance') || [];  
        const responseVenue = await this.getVenueData(this.props.ticketSelection.event_date_id);
        if (seats.length && !responseVenue.data.error) {
            seats.forEach(seat => {
                const sections = responseVenue.data.venue.sections;
                sections.forEach(section => {
                    if (parseInt(seat.dataset.sectionId, 0) === section.section_id) {
                        section.rows.forEach(row => {
                            if (parseInt(seat.dataset.rowId, 0) === row.row_id) {
                                row.seats.forEach(venueSeat => {
                                    if (parseInt(seat.dataset.seatId, 0) === venueSeat.seat_id) {
                                        seat.setAttribute('data-seat-status', venueSeat.status);
                                        seat.classList.remove('held');
                                        seat.classList.remove('reserved');
                                        seat.classList.remove('social-distance');
                                        seat.classList.add(venueSeat.status);
                                    }
                                })
                            }
                        });
                    }
                });
            });
        }
    }

    listenToChannel = () => {
        console.log('Reaches listenToChannel');
        channel = window.Ably.channels.get(`seat-availability:${this.props.ticketSelection.event_date_id}`);
        console.log('Ably channel: ', channel);
        channel.subscribe('seat-update', (message) => {
            console.log('seat-update', message.data);
            let seats = document.querySelectorAll('.clickable-seat');
            seats.forEach((seat) => {
                if(parseInt(seat.dataset.seatId) === message.data.seat_id && 
                    parseInt(seat.dataset.sectionId) === message.data.section_id && 
                    parseInt(seat.dataset.rowId) === message.data.row_id &&
                    parseInt(seat.dataset.eventDateId) === message.data.event_date_id) {
                    seat.classList.remove("available", "held", "released", "sold", "social-distance");
                    message.data.status === "released" ? seat.setAttribute('data-seat-status','available') : seat.setAttribute('data-seat-status', message.data.status);
                    message.data.status === "released" ? seat.classList.add("available") : seat.classList.add(message.data.status);
                    message.data.status !== "released" && seat.setAttribute('aria-label', `${seat.dataset.tooltip} - ${message.data.status}`);
                }
            });

        });
    }
    
    componentWillUnmount() {
        console.log('componentWillUnmount')
        channel.unsubscribe('seat-update');
    }

    componentWillUpdate(prevProps) {
        const { refresh } = this.props;
        if (prevProps.refresh !== refresh) {
            this.getVenue();
            this.handleChange(this.props.ticketSelection.zoom_level);
            this.updateSeats();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.ticketSelection.event_date_id !== this.props.ticketSelection.event_date_id) {
            this.clearHeldStatusFromDom();
            console.log('clearHeldStatusFromDom');
        }
        this.updateSeats();
    }

    render() { 
        var divStyle = {
            width: '1000px'
        };
        var panStyle = {
            height: '500px',
            width: '100%'
        };
        let eventDate = this.props.ticketSelection.date;//.substring(0, 16).replace('T', ' ');
        let eventDateString = moment(eventDate.substring(0, 19)).format('LLLL').toString();//moment(eventDate).format('LLLL');
        return ( 
            <React.Fragment>
                <EventPriceOptionsModal
                    isEventPriceOptionsOpen={this.state.isEventPriceOptionsOpen}
                    toggleEventPriceOption={this.toggleEventPriceOption}
                    confirmEventPriceOption={this.confirmEventPriceOption}
                    pricingOptions={this.state.pricingOptions}
                    currentPrice={this.state.currentPrice}
                    handlePriceChange={this.handlePriceChange}
                    user={this.props.user}
                    type={this.state.type}
                    transactionId={this.state.transactionId}
                    customerName={this.state.customerName}
                    section_name={this.state.section_name}
                    row_name={this.state.row_name}
                    seat_name={this.state.seat_name}
                    is_social_distance={this.state.is_social_distance}
                />
                <Message
                    message={this.state.message}
                />
                {this.state.isFullScreen && (
                    <div
                        className="showtix-tickets__overlay"
                        onClick={this.toggleFullScreen}
                    >
                    </div>
                )}
                <div className={this.state.isFullScreen ? "showtix-tickets mt-3 mb-3 is-full-screen" : "showtix-tickets mt-3 mb-3"} id="tickets">
                    <button
                        className={"showtix-category__button showtix-category__button__tickets" + (this.props.isTicketsOpen ? ' is-active' : '')}
                        onClick={() => this.props.toggleTickets()}
                        aria-expanded={this.props.isTicketsOpen}
                        aria-controls='reserved-seating'
                        id="ticket-button"
                    >{strings.ticketSelection} <i></i>
                    </button>
                    <div id="reserved-seating" className={"showtix-tickets__content " + (this.props.isTicketsOpen ? 'is-active' : '')}>
                        <div className="showtix-section showtix-background__primary-1">
                            <h2>{ReactHtmlParser(this.props.ticketSelection.name)} - {eventDateString}</h2>
                            <div className="showtix-seats-selection">
                                <div className="d-flex justify-content-between">
                                    {this.state.isQuickSelect ?
                                        <div className="quick-selection-icon">
                                            <img src={quickSelectionIcon} alt="" />
                                        </div>
                                    : 
                                        <div style={{width: 35}}></div>
                                    }
                                    {this.props.user.role &&
                                        <button
                                            className="showtix-button showtix-button__xsmall showtix-background__grey-3 mb-2"
                                            onClick={this.quickSelect}
                                            children={this.state.isQuickSelect ? 'Normal Mode' : '⚡ Quick Selection Mode'} />
                                    }
                                    <button
                                        className="showtix-seating__full-screen__button"
                                        onClick={this.toggleFullScreen}
                                        aria-expanded={this.state.isFullScreen}
                                        aria-controls="seating-chart"
                                        aria-label="Toggle full screen mode for Seating Chart"
                                    >
                                        <img src={fullScreenIcon} alt="" />
                                    </button>
                                </div>    
                                <div className="container">
                                    <div className="row">
                                        <div className="showtix-seating" id="seating-chart">
                                            <ElementPan style={panStyle} scale={this.state.zoom/100}>
                                                <div className="showtix-seating-wrapper" style={this.state.css}>
                                                    {ReactHtmlParser(this.state.rendered)}
                                                </div>
                                            </ElementPan>
                                        </div>
                                        <div className='showtix-slider' aria-hidden="true">
                                            <Slider
                                                min={20}
                                                max={120}
                                                step={1}
                                                value={this.state.zoom}
                                                tooltip={false}
                                                handleLabel={'Change the Zoom level of the Seating chart'}
                                                onChangeStart={this.handleChangeStart}
                                                onChange={this.handleChange}
                                                onChangeComplete={this.handleChangeComplete}
                                            />
                                            <div className='value'>{strings.zoom}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {this.generateSaveZoomVenue()}
                            <div className="container">
                                <div className="row">
                                    <div className="col-12 col-md-6 p-0">
                                        <div className="showtix-box mr-md-2 p-3">
                                            <h3 className="showtix-box__title">{strings.pricing}</h3>
                                            {this.state.venuePricingOptions.map((price, i) => { 
                                                return (
                                                    <div className="showtix-legend-row" key={i}>
                                                        <div>
                                                            {`${price.desc} - `}
                                                            {new Intl.NumberFormat('en-US', {
                                                                        style: 'currency',
                                                                    currency: 'USD'
                                                                }).format(price.amount)
                                                            }
                                                        </div>
                                                    </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6 p-0">
                                        <div className="showtix-box ml-md-2 p-3">
                                            <h3 className="showtix-box__title">{strings.legendTitle}</h3>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell available open">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.available}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell unavailable sold">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.sold}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell unavailable reserved">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.reserved}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell unavailable held">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.held}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell available wheelchair">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.wheelchair}
                                                </div>
                                            </div> 
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell available companion">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.companion}
                                                </div>
                                            </div>        
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell available handicap">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.handicap}
                                                </div>
                                            </div>     
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell available obstructed">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.obstructed}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell unavailable">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.unavailable}
                                                </div>
                                            </div>
                                            <div className="showtix-legend-row">
                                                <div>
                                                    <div className="seatCharts-seat seatCharts-cell unavailable social-distance">{strings.seat}</div>
                                                </div>
                                                <div>
                                                    {strings.socialDistance}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                {this.props.ticketSelection.artists.length > 0 &&
                                    <div className="row">
                                        <div className="d-flex mt-3">
                                            <div className="showtix-form__group">
                                                <label htmlFor="artistId" className="text-left font-weight-light showtix-color__white">{strings.credit}</label>
                                                <div className="showtix-form__select">
                                                    <select className="showtix-input"
                                                        object="ticketSelection"
                                                        id="artistId"
                                                        name="artistId"
                                                        value={this.props.ticketSelection.artistId}
                                                        onChange={e => this.props.handleCreditsSelection(e)}
                                                    >
                                                        <option value="undefined">{strings.selectArtist}</option>
                                                    {
                                                        this.props.ticketSelection.artists.map((artist, i) => <option key={i} value={artist.id}>{ReactHtmlParser(artist.first_name)} {ReactHtmlParser(artist.last_name)}, {artist.position}</option>)
                                                    }
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>    
                                }
                                <div className="row">
                                    <div className="d-flex col-12 justify-content-center mt-3">
                                        <button
                                            className="showtix-button showtix-background__primary-3"
                                            onClick={() => {
                                                for (let key in this.props.isCategoryOpen) {
                                                    this.props.isCategoryOpen[key] === true && this.props.toggleCategory(key)
                                                }
                                                this.props.toggleBilling(true);
                                                this.props.toggleTickets();
                                            }}
                                            disabled={this.props.cartItems.length === 0}
                                        >{strings.checkout}</button>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div> 
            </React.Fragment> 
        )
    }
}
 
export default ReservedSeating;



// WEBPACK FOOTER //
// ./src/components/EventListing/ReservedSeating/ReservedSeating.js